import React from 'react';
import { VideoIcon } from './icons/VideoIcon';
const modules = [{
  title: 'MÓDULO 1 – BIENVENIDA Y BASES PROFESIONALES',
  image: 'https://cdn.magicpatterns.com/uploads/qv6YXcY5HU3ZqE5PhbPfUX/modulo_1.png',
  lessons: ['Presentación de la instructora', 'Bienvenida al BB Lips Hidratación Profunda', 'Qué es el BB Lips y cómo funciona', 'Beneficios del BB Lips', 'Beneficios reales para el cliente', 'Estructura anatómica de los labios']
}, {
  title: 'MÓDULO 2 – HERRAMIENTAS, PRODUCTOS Y SEGURIDAD',
  image: 'https://cdn.magicpatterns.com/uploads/bZoQZKpVtGzRwwoQUrN3uX/modulo_2.png',
  lessons: ['Qué es y cómo usar el Dermapen', 'Productos que se aplican en BB Lips', 'Utensilios necesarios para el procedimiento', 'Bioseguridad y manejo profesional', 'Contraindicaciones (cuándo NO realizar el tratamiento)']
}, {
  title: 'MÓDULO 3 – PROCEDIMIENTO PASO A PASO (PRÁCTICA REAL)',
  image: 'https://cdn.magicpatterns.com/uploads/jM5q4HGqcRMAqbD8cp6Wy7/modulo_3.png',
  lessons: ['Procedimiento completo BB Lips paso a paso', 'Cuántas sesiones se necesitan', 'Práctica guiada paso a paso', 'Preparación y test de la modelo', 'Desinfección y limpieza correcta del labio', 'Aplicación y remoción de anestesia', 'Aplicación con vaselina', 'Cómo colocar y remover el algodón correctamente']
}, {
  title: 'MÓDULO 4 – TÉCNICA, COLOR Y CALIBRACIÓN',
  image: 'https://cdn.magicpatterns.com/uploads/6FbqHsjnYGVRc8gjbcEprq/modulo_4.png',
  lessons: ['Selección del color para BB Lips', 'Selección correcta de la aguja', 'Calibración del Dermapen', 'Uso profesional del Dermapen', 'Aplicación del color paso a paso', 'Aplicación de agua destilada', 'Aplicación de la capa de color']
}, {
  title: 'MÓDULO 5 – FINALIZACIÓN Y RESULTADOS',
  image: 'https://cdn.magicpatterns.com/uploads/wdjp39drHGXfqcrhts2W5u/modulo_5.1.png',
  lessons: ['Finalización del procedimiento', 'Cuidados después del tratamiento', 'Resultado real a las 24 horas', 'Recomendaciones para mejores resultados']
}];
export function CourseModules() {
  return <section id="contenido" className="py-12 px-4 bg-white" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <div className="text-center mb-10 space-y-3" data-id="element-21">
          <div className="inline-flex items-center gap-2 text-[#E5A5A0] mb-1" data-id="element-22">
            <VideoIcon className="w-4 h-4" data-id="element-23" />
          </div>
          <h2 className="text-2xl md:text-3xl font-semibold text-[#3D3028]" data-id="element-24">
            MÁS DE 30 LECCIONES EN VIDEO – PASO A PASO
          </h2>
          <p className="text-sm md:text-base text-[#3D3028]/70 max-w-2xl mx-auto" data-id="element-25">
            Accedés a una capacitación audiovisual completa, organizada en
            módulos claros y fáciles de seguir.
          </p>
        </div>

        <div className="space-y-4" data-id="element-26">
          {modules.map((module, moduleIndex) => <div key={moduleIndex} className="bg-[#FAF8F4] rounded-xl overflow-hidden border border-[#D4C4B0]/20" data-id="element-27">
              <div className="bg-[#3D3028] px-6 py-3" data-id="element-28">
                <h3 className="text-[#FAF8F4] font-medium text-xs md:text-sm tracking-wide" data-id="element-29">
                  {module.title}
                </h3>
              </div>

              <div className="w-full" data-id="element-30">
                <img src={module.image} alt={module.title} className="w-full h-auto object-cover" data-id="element-31" />
              </div>

              <div className="p-6" data-id="element-32">
                <ul className="grid md:grid-cols-2 gap-3" data-id="element-33">
                  {module.lessons.map((lesson, lessonIndex) => <li key={lessonIndex} className="flex items-start gap-2" data-id="element-34">
                      <VideoIcon className="w-3.5 h-3.5 text-[#E5A5A0] mt-0.5 flex-shrink-0" data-id="element-35" />
                      <span className="text-[#3D3028]/80 text-xs md:text-sm leading-snug" data-id="element-36">
                        {lesson}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}